import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useLocation } from "react-router-dom";

function Homepage() {
  //console.log(trip);
  const params = useParams();

  let dates = "";
  console.log(params.trip);

  switch (params.trip) {
    case "June-2027":
      dates = "June 8 - 19, 2027";
      break;

    case "trip":
      dates = "";
      break;
  }

  return (
    <div className={styles.backgroundPicture}>
      <div className={styles.titleBox}>
        <h1>Go to the enchanting land of</h1>
        <p className={styles.title}>Greece</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>Walk in the footsteps of St. Paul.</p>
          <p>Visit great historical and cultural sites all over this land.</p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;

// //<div>
//         <img
//           className={styles.homePhoto}
//           src={GreeceTrip}
//           alt="Greece monastery"
//         />
//       </div>
